<div class="time-range-select" [formGroup]="formGroup">
  <div class="time-range-select-control">
    <label
      class="py-2 time-range-select-label col-form-label fw-semibold fs-6"
      [attr.for]="startControlName"
      [ngClass]="required ? 'required' : ''"
    >
      {{ label }}
    </label>
    <app-select
      [formControlName]="startControlName"
      [name]="startControlName"
      [labelMode]="LabelMode.NO_LABEL"
      [options]="startOptions"
      [searchable]="false"
      [clearable]="true"
      [required]="required"
      [isDisabled]="startDisabled"
      [error]="startError"
      [errorMessage]="startErrorMessage"
      [inputClass]="inputClass"
      classes="mb-0"
      (valueChange)="startValueChange.emit($event)"
    ></app-select>
  </div>

  <span class="time-range-select-separator">ถึง</span>

  <div class="time-range-select-control">
    <span class="py-2 time-range-select-label time-range-select-label-placeholder col-form-label fw-semibold fs-6">
      {{ label }}
    </span>
    <app-select
      [formControlName]="endControlName"
      [name]="endControlName"
      [labelMode]="LabelMode.NO_LABEL"
      [options]="endOptions"
      [searchable]="false"
      [clearable]="true"
      [required]="required"
      [isDisabled]="endDisabled"
      [error]="endError"
      [errorMessage]="endErrorMessage"
      [inputClass]="inputClass"
      classes="mb-0"
      (valueChange)="endValueChange.emit($event)"
    ></app-select>
  </div>
</div>
